import { render } from "./NewsLetter.vue?vue&type=template&id=5bc803bb&scoped=true"
import script from "./NewsLetter.vue?vue&type=script&lang=js"
export * from "./NewsLetter.vue?vue&type=script&lang=js"

import "./NewsLetter.vue?vue&type=style&index=0&id=5bc803bb&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc803bb"]])

export default __exports__